// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"ccd34592","6452":"5f50c5c2","6850":"2bbdc22c","6942":"99db5559","9337":"ccd34592"}[chunkId] + ".chunk.css";
};